import * as React from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { TabsContentProps } from './types';

/* -------------------------------------------------------------------------- */
/*                               Tabs Content                                 */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/* Use this with a Tabs.js component to render the content of your tabs       */
/* 
  const tabsContent = [
    { tabId: 1, component: <GeneralTabContent /> }, //Example of Component in Profile GeneralInformationTabsContent
    { tabId: 2, component: <PasswordTabContent /> },
    {
      tabId: 3,
      component: <MapOptionsTabContent />,
    },
  ];
    
  Tabs is a list of the tabs you want to render
  Active Tab the current active tab
  SetActiveTab your function to toggle de active tab                               
                                                                              */
/* -------------------------------------------------------------------------- */

const TabsContent: React.FC<TabsContentProps> = ({
  activeTab,
  tabsContent = [],
  fullHeight = false
}) => {
  return (
    <TabContent
      activeTab={activeTab}
      style={
        fullHeight
          ? {
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              flex: '1 1 auto',
              minHeight: 0
            }
          : {}
      }
    >
      {tabsContent.map((tabContent) => {
        const isActive = tabContent.tabId === activeTab;
        return (
          <TabPane
            key={`tabContent${tabContent.tabId}`}
            tabId={tabContent.tabId}
            style={
              fullHeight && isActive
                ? {
                    height: '100%',
                    flex: '1 1 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0
                  }
                : {}
            }
          >
            {tabContent.component}
          </TabPane>
        );
      })}
    </TabContent>
  );
};

export default TabsContent;
